// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1OymU","title":"Header_title__-gICm","left":"Header_left__3VuFF","clinicName":"Header_clinicName__3rN-t"};